export default "__VITE_ASSET__Dmbe3rM___"